export enum AccountingSoftwareAvailability {
  Available,
  UpgradePlan,
  ContactSales,
}

export type AccountingSoftware = {
  id: string;
  shortName: string;
  name: string;
  /** Company name associated on the accounting software integration-side */
  companyName?: string;
  icon: string;
  /** Availability for the current subscription plan, null when loading. */
  availability?: AccountingSoftwareAvailability | null;
  /** The accounting software is hidden (unavailable and cannot be enabled by the user). */
  hidden?: boolean | null;
};
